<template>
  <b-message class="mb-24px" :type="type" :has-icon="hasIcon" icon-size="is-medium">
    <prismic-rich-text class="content" :field="fragment.primary.message_content" />
  </b-message>
</template>

<script>
export default {
  props: {
    fragment: Object
  },
  computed: {
    type() {
      switch (this.fragment.primary.message_type) {
        case 'info':
          return 'is-info'
        case 'alert':
          return 'is-warning'
        case 'danger':
          return 'is-danger'
      }
      return ''
    },
    hasIcon() {
      return this.type ? true : false
    }
  }
}
</script>
